import React from 'react';
import Icon from '../../icons/Icon';
import SarFieldInfoButton from './SarFieldInfoModalComponent';
import SarFieldInfoBubbleButton from './components/SarFieldInfoBubble';

export interface FieldInfoButtonProps {
  label: string;
  infoConfig: {
    path: string;
    type?: string;
    additionalInfo?: string;
    mode?: 'bubble' | 'modal';
  };
  hasError?: boolean;
}

const FieldInfoButton = ({ label, infoConfig, hasError = false }: FieldInfoButtonProps): JSX.Element => {
  const iconElement = <Icon icon={'kyc_informationicon'} className={`text-f-black-2 hover:opacity-50 opacity-100 transition-opacity duration-200 ${hasError ? 'text-f-red-1' : ''}`} aria-label={'Information'} />;

  switch (infoConfig.mode) {
    case 'modal':
      return (
        <SarFieldInfoButton
          fieldPath={infoConfig.path}
          fieldLabel={label}
          fieldType={infoConfig.type ?? 'Metin'}
          additionalInfo={infoConfig.additionalInfo}
          trigger={iconElement}
        />
      );
    case 'bubble':
    default:
      return (
        <SarFieldInfoBubbleButton
          fieldPath={infoConfig.path}
          fieldLabel={label}
          fieldType={infoConfig.type ?? 'Metin'}
          additionalInfo={infoConfig.additionalInfo}
          trigger={iconElement}
        />
      );
  }
};

export default FieldInfoButton;


